import { render, staticRenderFns } from "./EditarDatoExtendidoModal.vue?vue&type=template&id=82df2892&scoped=true&"
import script from "./EditarDatoExtendidoModal.vue?vue&type=script&lang=ts&"
export * from "./EditarDatoExtendidoModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditarDatoExtendidoModal.vue?vue&type=style&index=0&id=82df2892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82df2892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('82df2892', component.options)
    } else {
      api.reload('82df2892', component.options)
    }
    module.hot.accept("./EditarDatoExtendidoModal.vue?vue&type=template&id=82df2892&scoped=true&", function () {
      api.rerender('82df2892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dispositivos/EditarDatoExtendidoModal.vue"
export default component.exports